import type { Subscription } from '@/types/domain'
import { http } from '@/platform/http'

export const subscriptionApi = {
  info: () => http.get<Subscription>('/subscription/info', { toastError: false }),
  cancel: () => http.post<string>('/subscription/cancel', {}),
  status: () => http.get<boolean>('/subscription/status', { toastError: false }),
}
